import { useJourneyData } from "@/hooks/use-journey-data";
import { isDenver } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";
import { MarketAvailability } from "./market-availability";

interface MarketLimitedComponentProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
  showRequestAccess?: boolean;
  className?: string;
  featureHighlights?: Array<{
    title: string;
    description: string;
    icon: LucideIcon;
  }>;
}

export function MarketLimitedComponent({
  children,
  title = "Coming Soon to Your Area",
  description = "This feature is currently available in Denver, CO. We're working hard to bring it to more cities.",
  showRequestAccess = true,
  className,
  featureHighlights,
}: MarketLimitedComponentProps) {
  const { journeyData } = useJourneyData();
  const isFromDenverCo = isDenver(journeyData?.shoppingLocation ?? "");

  if (!isFromDenverCo) {
    return (
      <div className="max-w-3xl mx-auto">
        <MarketAvailability
          title={title}
          description={description}
          showRequestAccess={showRequestAccess}
          className={className}
          featureHighlights={featureHighlights}
        />
      </div>
    );
  }

  return <>{children}</>;
}
